import { Select, SelectItem } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';

const PER_PAGE_OPTIONS = [10, 20, 30, 50] as const;

export function PerPageSelect({
  label,
  value,
  onChange,
}: {
  label?: string;
  value: number;
  onChange: (perPage: number) => void;
}) {
  const { t } = useTranslation('alocacao');
  const text = label ?? t('tabela.itensPorPagina');

  return (
    <div className="flex items-center gap-2">
      <span className="whitespace-nowrap text-sm text-foreground-muted">{text}</span>
      <Select
        size="sm"
        value={String(value)}
        onValueChange={(v) => onChange(Number(v))}
        aria-label={text}
      >
        {PER_PAGE_OPTIONS.map((option) => (
          <SelectItem key={option} value={String(option)}>
            {option}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}
